import { AxiosResponse } from 'axios';
import { postRequest } from '../base';

export const DashboardService = {
  get: async (from: number, to: number): Promise<AxiosResponse> =>
    postRequest(`get_ai_dashboard?from=${from}&to=${to}`),
};
